// Home 页面相关的翻译资源
export const homeResources = {
  zh: {
    // Hero section
    "home.hero.title": "致力于为创新和生育赋能",
    "home.hero.description": "我们相信，健康的人口结构与优质的教育是社会持续发展的基石。",
    
    // Purpose section
    "home.purpose.title": "成立宗旨",
    
    // What we do cards
    "home.whatWeDo.fertility.title": "促进生育",
    "home.whatWeDo.fertility.subtitle": "促进生殖健康与性别平等（惠及香港社区）",
    "home.whatWeDo.fertility.modal.intro": "透过以下方式（包括但不限于）:",
    "home.whatWeDo.fertility.description": "惠及香港社区，资助或设立非牟利诊所，于企业网络推广认知，增加因家庭原因暂离职场女性之重返就...",
    "home.whatWeDo.fertility.details.clinic.title": "资助或设立非牟利诊所，提供：",
    "home.whatWeDo.fertility.details.clinic.item1": "生育检查",
    "home.whatWeDo.fertility.details.clinic.item2": "不育夫妇资助治疗",
    "home.whatWeDo.fertility.details.clinic.item3": "孕期咨询",
    "home.whatWeDo.fertility.details.clinic.item4": "新生婴儿护理培训",
    "home.whatWeDo.fertility.details.item2": "于企业网络推广认知，增加因家庭原因暂离职场女性之重返就业机会",
    "home.whatWeDo.fertility.details.item3": "向推动此慈善目标的机构或个人拨款",
    
    "home.whatWeDo.education.title": "扶贫兴教",
    "home.whatWeDo.education.subtitle": "纾解贫困与推展教育",
    "home.whatWeDo.education.modal.intro": "透过以下方式（包括但不限于）:",
    "home.whatWeDo.education.description": "向新生儿家庭及母亲提供教育开支津贴，为需同时兼顾育儿及高等教育的个人（尤其女性）提供经济援...",
    "home.whatWeDo.education.details.item1": "向新生儿家庭及母亲提供教育开支津贴",
    "home.whatWeDo.education.details.item2": "向面临经济困难的育儿家庭提供援助，确保子女持续接受优质教育并享有家庭和睦",
    "home.whatWeDo.education.details.item3": "为需同时兼顾育儿及高等教育的个人（尤其女性）提供经济援助，纾缓其时间与财政压力",
    "home.whatWeDo.education.details.item4": "资助或设立具创新早教元素的非牟利托儿服务供公众使用",
    "home.whatWeDo.education.details.item5": "编制并派发家庭教育资源材料",
    
    "home.whatWeDo.poverty.title": "倡导家善",
    "home.whatWeDo.poverty.subtitle": "推广家庭友善的社会认知",
    "home.whatWeDo.poverty.modal.intro": "透过以下方式（包括但不限于）:",
    "home.whatWeDo.poverty.description": "结合宗旨扶贫兴教及促进生育的慈善活动，向公众推广共建家庭友善社会的认知；举办工作坊等活动，推动企业制订家庭友善政策标准...",
    "home.whatWeDo.poverty.details.item1": "结合宗旨扶贫兴教及促进生育的慈善活动，向公众推广共建家庭友善社会的认知",
    "home.whatWeDo.poverty.details.item2": "举办工作坊等活动，推动企业制订家庭友善政策标准",
    "home.whatWeDo.poverty.details.item3": "举办工作坊等活动，鼓励及装备父亲积极参与育儿",
    "home.whatWeDo.poverty.details.item4": "进行并发布公益研究，探讨人口趋势、妇女赋权、优质童教与社会创新的关联",
    "home.whatWeDo.poverty.details.item5": "筹办或资助学术研究及交流活动",
    "home.whatWeDo.poverty.details.item6": "向推动此慈善目标的机构或个人拨款",


    
    // Projects section
    "home.projects.title": "项目",
    "home.projects.more": "更多",
    
    // News section
    "home.news.title": "最近新闻",
    "home.news.more": "更多",

    "home.slogen.title": "创生观点",
    
    // Funding application section
    "home.funding.title": "申请资助",
    "home.funding.more": "更多",
    "home.funding.applyNow": "立即申请",
    "home.funding.step1.title": "确认资格",
    "home.funding.step1.description": "香港全日制在读博士生<br/>子女于 2026 年 1 月 1 日或以后出生",
    "home.funding.step1.note": "*如伴侣同资格，双方仅可提交一份申请",
    "home.funding.step2.title": "准备并提交文件",
    "home.funding.step2.description": "准备有效学生证、学校成绩单/在读证明、子女出生证明，在线填写并提交电子申请表",
    "home.funding.step3.title": "审批及拨款",
    "home.funding.step3.description": "我们将于收齐文件后14个工作日内完成审批<br/>若审批通过后将于5个工作日内发放补助金",
    
    // Contact section
    "home.contact.title": "联系我们",
    "home.contact.description": "如果您对我们的基金会有任何问题或咨询",
    "home.contact.description2": "请与我们联系",
    "home.contact.hours": "服务时间：周一至周五 早上8:00 - 下午5:00",
    "home.contact.phone": "电话",
    "home.contact.email": "Email",
    "home.contact.email.link": "info@genovationfoundation.org",

  },
  zh_TW: {
    // Hero section
    "home.hero.title": "致力於為創新和生育賦能",
    "home.hero.description": "我們相信，健康的人口結構與優質的教育是社會持續發展的基石。",
    
    // Purpose section
    "home.purpose.title": "成立宗旨",
    
    // What we do cards
    "home.whatWeDo.fertility.title": "促進生育",
    "home.whatWeDo.fertility.subtitle": "促進生殖健康與性別平等（惠及香港社區）",
    "home.whatWeDo.fertility.modal.intro": "透過以下方式（包括但不限於）:",
    "home.whatWeDo.fertility.description": "惠及香港社區，資助或設立非牟利診所，於企業網路推廣認知，增加因家庭原因暫離職場女性之重返就...",
    "home.whatWeDo.fertility.details.clinic.title": "資助或設立非牟利診所，提供：",
    "home.whatWeDo.fertility.details.clinic.item1": "生育檢查",
    "home.whatWeDo.fertility.details.clinic.item2": "不育夫婦資助治療",
    "home.whatWeDo.fertility.details.clinic.item3": "孕期諮詢",
    "home.whatWeDo.fertility.details.clinic.item4": "新生嬰兒護理培訓",
    "home.whatWeDo.fertility.details.item2": "於企業網路推廣認知，增加因家庭原因暫離職場女性之重返就業機會",
    "home.whatWeDo.fertility.details.item3": "向推動此慈善目標的機構或個人捐款",
    
    "home.whatWeDo.education.title": "扶貧興教",
    "home.whatWeDo.education.subtitle": "紓解貧困與推展教育",
    "home.whatWeDo.education.modal.intro": "透過以下方式（包括但不限於）:",
    "home.whatWeDo.education.description": "向新生兒家庭及母親提供教育開支津貼，為需同時兼顧育兒及高等教育的個人（尤其女性）提供經濟援...",
    "home.whatWeDo.education.details.item1": "向新生兒家庭及母親提供教育開支津貼",
    "home.whatWeDo.education.details.item2": "向面臨經濟困難的育兒家庭提供援助，確保子女持續接受優質教育且家庭和睦",
    "home.whatWeDo.education.details.item3": "為需同時兼顧育兒及高等教育的個人（尤其女性）提供經濟援助，紓緩其時間與財政壓力",
    "home.whatWeDo.education.details.item4": "資助或設立具創新早教元素的非牟利托兒服務供公眾使用",
    "home.whatWeDo.education.details.item5": "編制並派發家庭教育資源材料",
    
    "home.whatWeDo.poverty.title": "宣導家善",
    "home.whatWeDo.poverty.subtitle": "推廣家庭友善的社會認知",
    "home.whatWeDo.poverty.modal.intro": "透過以下方式（包括但不限於）:",
    "home.whatWeDo.poverty.description": "結合宗旨扶貧興教及促進生育的慈善活動，向公眾推廣共建家庭友善社會的認知；舉辦工作坊等活動，推動企業制訂家庭友善政策標準",
    "home.whatWeDo.poverty.details.item1": "結合宗旨扶貧興教及促進生育的慈善活動，向公眾推廣共建家庭友善社會的認知",
    "home.whatWeDo.poverty.details.item2": "舉辦工作坊等活動，推動企業制訂家庭友善政策標準",
    "home.whatWeDo.poverty.details.item3": "舉辦工作坊等活動，鼓勵及裝備父親積極參與育兒",
    "home.whatWeDo.poverty.details.item4": "進行並發佈公益研究，探討人口趨勢、婦女賦權、優質童教與社會創新的關聯",
    "home.whatWeDo.poverty.details.item5": "籌辦或資助學術研究及交流活動",
    "home.whatWeDo.poverty.details.item6": "向推動此慈善目標的機構或個人捐款",
    
    // Projects section
    "home.projects.title": "項目",
    "home.projects.more": "更多",
    
    // News section
    "home.news.title": "最近新聞",
    "home.news.more": "更多",

    "home.slogen.title": "創生觀點",
    
    // Funding application section
    "home.funding.title": "申請資助",
    "home.funding.more": "更多",
    "home.funding.applyNow": "立即申請",
    "home.funding.step1.title": "確認資格",
    "home.funding.step1.description": "香港全日制在讀博士生<br/>子女於 2026 年 1 月 1 日或以後出生",
    "home.funding.step1.note": "*如伴侶同資格，雙方僅可提交一份申請",
    "home.funding.step2.title": "準備並提交文件",
    "home.funding.step2.description": "準備有效學生證、學校成績單/在讀證明、子女出生證明，在線填寫並提交電子申請表",
    "home.funding.step3.title": "審核及撥款",
    "home.funding.step3.description": "我們將於收齊文件後14個工作日內完成審核<br/>若審批通過後將於5個工作日內發放補助金",
    
    // Contact section
    "home.contact.title": "聯繫我們",
    "home.contact.description": "如果您對我們的基金會有任何問題或諮詢",
    "home.contact.description2": "請與我們聯繫",
    "home.contact.hours": "服務時間：週一至週五 早上8:00 - 下午5:00",
    "home.contact.phone": "電話",
    "home.contact.email": "Email",
    "home.contact.email.link": "info@genovationfoundation.org",

  },
  en: {
    // Hero section
    "home.hero.title": "Empowering Reproduction and Innovation",
    "home.hero.description": "We believe that a healthy population structure and quality education are the cornerstones of sustainable social development.",
    
    // Purpose section
    "home.purpose.title": "Our Mission",
    
    // What we do cards
    "home.whatWeDo.fertility.title": "Promote Childbirth",
    "home.whatWeDo.fertility.subtitle": "Promoting Reproductive Health and Gender Equality (Benefiting Hong Kong Community)",
    "home.whatWeDo.fertility.modal.intro": "Through the following methods (including but not limited to):",
    "home.whatWeDo.fertility.description": "Benefiting Hong Kong community, funding or establishing non-profit clinics, promoting awareness through corporate networks, increasing re-employment opportunities for women who temporarily left the workplace due to family reasons...",
    "home.whatWeDo.fertility.details.item1": "Providing financial support to or setting up non-profit clinics for providing fertility tests and providing subsidized treatment for couples with fertility challenges, providing consulting during pregnancy, and providing training for new parents after birth on how to take care of newborns",
    "home.whatWeDo.fertility.details.item2": "Promoting awareness amongst a network of companies to increase job opportunities for women returning to work after a pause in their career because of family reasons; and",
    "home.whatWeDo.fertility.details.item3": "Making grants to other organizations or individuals furthering this charitable object",
    
    "home.whatWeDo.education.title": "Poverty Alleviation and Educational Promotion",
    "home.whatWeDo.education.subtitle": "Alleviating poverty and advancing education",
    "home.whatWeDo.education.modal.intro": "Through the following methods (including but not limited to):",
    "home.whatWeDo.education.description": "Provide education subsidies to families with newborns and mothers, provide financial assistance to individuals (especially women) who need to balance childcare and higher education...",
    "home.whatWeDo.education.details.item1": "Providing financial subsidies to families and mothers with newborns on education-related spending",
    "home.whatWeDo.education.details.item2": "Providing financial assistance to families with children that may be experiencing financial difficulties so children can continue to receive good education and experience family harmony",
    "home.whatWeDo.education.details.item3": "Providing financial assistance to individuals, particularly women, who are struggling to balance the time and financial needs between raising young children and pursuing higher education",
    "home.whatWeDo.education.details.item4": "Providing financial support to or setting up non-profit daycare services with innovative early education elements for the general public",
    "home.whatWeDo.education.details.item5": "Creating and disseminating education materials for families raising children",
    
    "home.whatWeDo.poverty.title": "Promote Family Virtues",
    "home.whatWeDo.poverty.subtitle": "Promote family-friendly social awareness",
    "home.whatWeDo.poverty.modal.intro": "Through the following methods (including but not limited to):",
    "home.whatWeDo.poverty.description": "Promoting awareness amongst the general public, through and in addition to the charitable activities to be carried out under charitable objects \"Promote Childbirth\" and \" Poverty alleviation and educational promotion\", on how to support a family-friendly society",
    "home.whatWeDo.poverty.details.item1": "Promoting awareness amongst the general public, through and in addition to the charitable activities to be carried out under charitable objects \"Promote Childbirth\" and \" Poverty alleviation and educational promotion\", on how to support a family-friendly society",
    "home.whatWeDo.poverty.details.item2": "Conducting workshops and other activities to promote good corporate standards amongst companies for family-friendly policies",
    "home.whatWeDo.poverty.details.item3": "Conducting workshops and other activities to encourage and equip fathers to play a bigger role in raising children",
    "home.whatWeDo.poverty.details.item4": "Conducting and disseminating, for public benefit, research on the relationship between demographic trends, women empowerment, better education for children, and innovation in a society",
    "home.whatWeDo.poverty.details.item5": "Organizing or providing funding for academic research and academic exchange",
    "home.whatWeDo.poverty.details.item6": "Making grants to other organizations or individuals furthering this charitable object",
    
    // Projects section
    "home.projects.title": "Projects",
    "home.projects.more": "More",
    
    // News section
    "home.news.title": "Latest News",
    "home.news.more": "More",

    "home.slogen.title": "Genovation Insights",
    
    // Funding application section
    "home.funding.title": "Apply",
    "home.funding.more": "More",
    "home.funding.applyNow": "Apply Now",
    "home.funding.step1.title": "Verify Eligibility",
    "home.funding.step1.description": "Full-time PhD students in Hong Kong<br/>Children born on or after January 1, 2026.",
    "home.funding.step1.note": "*If your partner is also eligible, only one application can be submitted",
    "home.funding.step2.title": "Prepare and Submit Documents",
    "home.funding.step2.description": "Prepare valid student ID, academic transcript/enrollment certificate, child's birth certificate. Fill in and submit the application form online.",
    "home.funding.step3.title": "Review and Disbursement",
    "home.funding.step3.description": "We will complete the review within 14 working days after receiving all documents.<br/>If approved, the grant will be disbursed within 5 working days.",
    
    // Contact section
    "home.contact.title": "Contact Us",
    "home.contact.description": "If you have any questions or inquiries about our foundation, please contact us.",
    "home.contact.description2": "",
    "home.contact.hours": "Service Hours: Monday to Friday 8:00 AM - 5:00 PM",
    "home.contact.phone": "Phone",
    "home.contact.email": "Email",
    "home.contact.email.link": "info@genovationfoundation.org",
  }
};

